/**
 * Wraps a number at a given value.
 *
 * @param {number} x Array index
 * @param {number} n Array length
 */
export function modulo(x, n) {
	return ((x % n) + n) % n;
}
